import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b3c8001"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vu_main" }
const _hoisted_2 = { class: "vu_content" }
const _hoisted_3 = { class: "vu_content_type" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vu_content_type_tds" }, "版本类别", -1))
const _hoisted_5 = { class: "vctt_title" }
const _hoisted_6 = { class: "vctt_title vctt_sub_title" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "vctt_content" }
const _hoisted_9 = { class: "version_title" }
const _hoisted_10 = { class: "vctt_status" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "荐", -1))
const _hoisted_13 = { class: "vctt_title" }
const _hoisted_14 = { class: "vctt_title vctt_sub_title" }
const _hoisted_15 = { class: "vctt_content" }
const _hoisted_16 = { class: "vctt_status" }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  class: "vctt_info_content"
}
const _hoisted_19 = { class: "vu_content_feature" }
const _hoisted_20 = { class: "vctt_tb" }
const _hoisted_21 = { class: "vu_content_feature" }
const _hoisted_22 = { class: "vctt_tb" }
const _hoisted_23 = { class: "vu_content_feature" }
const _hoisted_24 = { class: "vctt_tb" }
const _hoisted_25 = { class: "vu_content_feature" }
const _hoisted_26 = { class: "vctt_tb" }
const _hoisted_27 = { class: "vu_content_feature" }
const _hoisted_28 = { class: "vctt_tb" }
const _hoisted_29 = { class: "vu_content_feature" }
const _hoisted_30 = { class: "vctt_tb" }
const _hoisted_31 = { class: "vu_content_feature" }
const _hoisted_32 = { class: "vctt_tb" }
const _hoisted_33 = { class: "vu_content_feature" }
const _hoisted_34 = { class: "vctt_tb" }
const _hoisted_35 = { class: "vu_content_feature" }
const _hoisted_36 = { class: "vctt_tb" }
const _hoisted_37 = { class: "vu_content_feature" }
const _hoisted_38 = { class: "vctt_tb" }
const _hoisted_39 = { class: "vu_content_feature" }
const _hoisted_40 = { class: "vctt_tb" }

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { Version } from '.././types';
import TableHead from './versionCell/TableHead.vue';
import TableTd from './versionCell/TableTd.vue';
import { VersionPlate } from '@/assets';


export default /*#__PURE__*/_defineComponent({
  __name: 'OldVersion',
  props: {
    list: null,
    arr: null
  },
  setup(__props: any) {

const props = __props as {
  list: Version[];
  arr: Version[];
};

const router = useRouter();

const customVersion = computed(() => {
  const array = props.arr.filter((e: Partial<Version>) => e.role_info?.version_id === 0);
  return array[0];
});
const versionList = computed(() => props.list);
const handleGoUp = (index: number) => {
  router.push({ name: 'WalletPay', params: { goods_id: '1-' + index } });
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "vu_content_type_td",
            style: _normalizeStyle({
            background: 'linear-gradient(180deg, ' + item.role_info.bg_color[0] + ' 0%, ' + item.role_info.bg_color[1] + ' 100%)',
          }),
            key: index
          }, [
            _createElementVNode("h4", _hoisted_5, _toDisplayString(item.role_info.role_type), 1),
            _createElementVNode("h5", _hoisted_6, _toDisplayString(item.role_info.role_code), 1),
            (item.role_info.customized === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(item.role_info.price) + " 元/年", 1),
                    _withDirectives(_createElementVNode("p", { class: "version_title dec" }, _toDisplayString(item.role_info.origin_price) + " 元/年", 513), [
                      [_vShow, item.role_info.discount]
                    ])
                  ]),
                  (item.role_info.buy_status)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        class: "vctt_btn",
                        onClick: ($event: any) => (handleGoUp(item.role_info.version_id))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("立即升级")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", _hoisted_10, [
                    _createElementVNode("img", {
                      src: _unref(VersionPlate),
                      alt: ""
                    }, null, 8, _hoisted_11),
                    _hoisted_12
                  ], 512), [
                    [_vShow, item.role_info.recommend === 1]
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 4))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(customVersion), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "vu_content_type_td",
            style: _normalizeStyle({
            background:
              'linear-gradient(180deg, ' +
              _unref(customVersion).role_info.bg_color[0] +
              ' 0%, ' +
              _unref(customVersion).role_info.bg_color[1] +
              ' 100%)',
          }),
            key: index
          }, [
            _createElementVNode("h4", _hoisted_13, _toDisplayString(_unref(customVersion).role_info.role_type), 1),
            _createElementVNode("h5", _hoisted_14, _toDisplayString(_unref(customVersion).role_info.role_type), 1),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", null, _toDisplayString(_unref(customVersion).role_info.title), 1),
                _createElementVNode("p", null, _toDisplayString(_unref(customVersion).role_info.contact), 1),
                _createElementVNode("p", null, _toDisplayString(_unref(customVersion).role_info.tel), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("img", {
                  src: _unref(VersionPlate),
                  alt: ""
                }, null, 8, _hoisted_17),
                _createVNode(_component_svg_icon, {
                  "icon-class": "crown",
                  class: "txt kind"
                })
              ]),
              (_unref(customVersion).role_info.content)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(customVersion).role_info.content, (o, index) => {
                      return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(o), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(TableHead, {
            icon: "version_feature",
            title: "资源配置"
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "vctt_tb",
            key: index
          }, [
            _createVNode(TableTd, {
              "node-data": item.resources_config
            }, null, 8, ["node-data"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(TableHead, {
            icon: "version_resources",
            title: "直播模式"
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "vctt_tb",
            key: index
          }, [
            _createVNode(TableTd, {
              "node-data": item.mode
            }, null, 8, ["node-data"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(TableHead, {
            icon: "version_tool",
            title: "页面装饰"
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "vctt_tb",
            key: index
          }, [
            _createVNode(TableTd, {
              "node-data": item.decorate
            }, null, 8, ["node-data"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(TableHead, {
            icon: "version_interactive",
            title: "直播管理"
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "vctt_tb",
            key: index
          }, [
            _createVNode(TableTd, {
              "node-data": item.live_administer
            }, null, 8, ["node-data"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createVNode(TableHead, {
            icon: "version_live",
            title: "营销互动"
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "vctt_tb",
            key: index
          }, [
            _createVNode(TableTd, {
              "node-data": item.interaction
            }, null, 8, ["node-data"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(TableHead, {
            icon: "version_authorization",
            title: "安全设置"
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "vctt_tb",
            key: index
          }, [
            _createVNode(TableTd, {
              "node-data": item.safe_set
            }, null, 8, ["node-data"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(TableHead, {
            icon: "version_media",
            title: "数据统计"
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "vctt_tb",
            key: index
          }, [
            _createVNode(TableTd, {
              "node-data": item.data
            }, null, 8, ["node-data"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createVNode(TableHead, {
            icon: "version_count",
            title: "品牌定制"
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "vctt_tb",
            key: index
          }, [
            _createVNode(TableTd, {
              "node-data": item.customized
            }, null, 8, ["node-data"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createVNode(TableHead, {
            icon: "version_control",
            title: "运维服务"
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "vctt_tb",
            key: index
          }, [
            _createVNode(TableTd, {
              "node-data": item.service
            }, null, 8, ["node-data"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createVNode(TableHead, {
            icon: "version_custom",
            title: "开发支持"
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "vctt_tb",
            key: index
          }, [
            _createVNode(TableTd, {
              "node-data": item.support
            }, null, 8, ["node-data"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _createVNode(TableHead, {
            icon: "version_heart",
            title: "私有部署"
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "vctt_tb",
            key: index
          }, [
            _createVNode(TableTd, {
              "node-data": item.private
            }, null, 8, ["node-data"])
          ]))
        }), 128))
      ])
    ])
  ], 512)), [
    [_vShow, Object.keys(_unref(versionList)).length]
  ])
}
}

})